import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { getConsent, setConsent } from "@/lib/consent";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (getConsent() === null) {
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const handle = (state: "accepted" | "rejected") => {
    setConsent(state);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ type: "spring", damping: 22, stiffness: 220 }}
          className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-[9998]"
          role="dialog"
          aria-live="polite"
          aria-label="Aviso de cookies"
        >
          <div
            className="rounded-2xl border border-white/30 shadow-2xl p-5 text-foreground"
            style={{
              background:
                "linear-gradient(135deg, rgba(255,255,255,0.92) 0%, rgba(230,240,250,0.92) 100%)",
              backdropFilter: "blur(16px) saturate(1.6)",
            }}
          >
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-xl bg-primary/15 flex items-center justify-center shrink-0">
                <Cookie className="w-5 h-5 text-primary" />
              </div>
              <div className="flex-1">
                <h3 className="font-heading font-semibold text-base mb-1">
                  Sua privacidade importa
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  Usamos cookies para melhorar sua experiência e analisar o tráfego. Em
                  conformidade com a LGPD (Lei 13.709/2018), você pode aceitar ou recusar
                  cookies de análise.{" "}
                  <Link
                    to="/politica-de-privacidade"
                    className="text-primary hover:underline font-medium"
                  >
                    Política de Privacidade
                  </Link>
                  .
                </p>
                <div className="flex gap-2 mt-4">
                  <Button
                    type="button"
                    variant="outline"
                    onClick={() => handle("rejected")}
                    className="flex-1 bg-card/60 hover:bg-card/80 backdrop-blur-sm"
                  >
                    Recusar
                  </Button>
                  <Button
                    type="button"
                    onClick={() => handle("accepted")}
                    className="flex-1 font-bold bg-gradient-to-r from-primary to-accent hover:opacity-90"
                  >
                    Aceitar
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
